/**
 * Settings → Templates' words about an unfilled template (docs/specs/player-import.md PI71, §9). Locked rule 9 says
 * a template a room has not filled in cannot be used; the players template is its one exception (ADR 0021), so the
 * pane says so wherever the room sees that template rather than stating the rule as universal.
 */

const INTRO = "Defined by the platform. A template you haven't filled in can't be used by this room";

const isPlayers = (template: { purpose: string }) => template.purpose === 'import_players';

/** The pane's opening line, naming the players template as the exception when it is listed. */
export function paneIntro(rows: readonly { template: { name: string; purpose: string } }[]): string {
  const players = rows.find((r) => isPlayers(r.template));
  return players
    ? `${INTRO}, except ${players.template.name}, which reads every column until you fill it in.`
    : `${INTRO}.`;
}

/** §9's line under an unfilled players template; null for any other template, and for a filled one. */
export function unfilledNote(entry: { template: { purpose: string }; content: unknown }): string | null {
  return isPlayers(entry.template) && entry.content === null ? 'Until you fill it in, imports read every column.' : null;
}
